module.exports = __webpack_public_path__ + "media/images/icons/linkedin_circle-8d9597c608170595f5cb13201c67c7ef.svg";